<script setup lang="ts">
import { reactive, watch, onMounted } from "vue";

const props = withDefaults(defineProps<{
    query: string
    placeholder?: string
    buttonText?: string
}>(), {
    query: "",
    placeholder: "Vul een zoekwoord in...",
    buttonText: "Zoek",
})

const emit = defineEmits<{
    (e: "execute-search", value: string): void
    (e: "clear-query"): void
}>()

const state = reactive({
    query: "",
})

watch(
    () => props.query,
    (value) => {
        state.query = value
    }
)

onMounted(() => {
    state.query = props.query
})
</script>

<template>
    <div class="d-flex">
        <input v-model="state.query" type="text" class="form-control mr-1" :placeholder="placeholder"
            autocomplete="off" />
        <button class="btn btn-secondary" :title="props.buttonText" :aria-label="props.buttonText"
            @click="$emit('execute-search', state.query)">
            <span>{{ buttonText }}</span>
        </button>
    </div>
</template>